import { render, staticRenderFns } from "./MediaGeral.vue?vue&type=template&id=60899894&lang=pug&"
import script from "./MediaGeral.vue?vue&type=script&lang=js&"
export * from "./MediaGeral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports